export const NO_CATEGORY = {
  id: null as null,
  title: 'Sem Categoria',
} as const;

export const KB_1 = 1024;
export const MB_1 = KB_1 * 1024;
